<template lang="html">
        <div class="row">
            <!-- MY TEAM  -->
            <div v-if="myTeamGroups.length > 0" class="col-sm-3">
                <button class="channelBtn w-100 btn bg-lightest radius-normal darker bold fs-large" @click="selectChannel('myTeam')" :class="{'selected':value.length > 0 && value[0].channelType == 9999}">
                    <div class="">
                        <span class="myTeamTitle">My team</span>
                        <div v-for="group in myTeamGroups" class="myTeamGroup fs-smaller">
                            {{group.name}}
                        </div>
                    </div>
                </button>
            </div>

            <!-- OTHER CHANNELS -->
            <div v-for="salesChannel in regularChannels" class="col-sm-3">
                <button class="channelBtn w-100 btn bg-lightest radius-normal darker bold fs-large" @click="selectChannel(salesChannel)" :class="{'selected':value.length > 0 && value[0].id == salesChannel.id}">
                    <div>{{salesChannel.name}}</div>
                </button>
            </div>
        </div>
</template>

<script>
export default {
    props:{
        value:{
            type: Array,
        },
        reservation: {
            type: Object
        }
    },
    computed: {
        availableChannels: function () {
            let channelsArray = []

            // Channels from Gender Prices
            channelsArray = this.reservation.bookingGenderPrices.filter(bookingGenderPrice => bookingGenderPrice.quantityToBook > 0).map(bookingGenderPrice => bookingGenderPrice.channel)

            // Channels from Extras
            for (let bookingComponent of this.reservation.bookingComponents) {
                channelsArray.push(bookingComponent.channel)
            }

            return channelsArray
        },
        availableChannelsNoDupes: function () {
            // Remove dupes
            let arrayUnique = []
            for (let channel of this.availableChannels) {
                if(arrayUnique.length == 0 || arrayUnique.filter(uniqueItem => uniqueItem.id == channel.id).length == 0){
                    arrayUnique.push(channel)
                }
            }
            return arrayUnique
        },
        regularChannels: function () {
            // RETURNS ALL CHANNELS EXCEPT "MY TEAM" ONES
            return this.availableChannelsNoDupes.filter(item => item.channelType != 9999)
        },
        myTeamGroups: function () {
            return this.availableChannelsNoDupes.filter(item => item.channelType == 9999)
        }
    },
    methods: {
        selectChannel: function (salesChannel) {
            if(salesChannel == 'myTeam'){
                this.$emit('input', this.myTeamGroups)
            } else {
                this.$emit('input', [salesChannel])
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_utility.scss";

.channelBtn{
    @extend .border-medium;
    height: 60px;

    .myTeamTitle{
        display: block;
        line-height: 1.2em;
    }

    .myTeamGroup{
        line-height: 1.2em;
    }

    &:hover{
        @extend .bg-lighter;
    }

    &.selected{
        @extend .border-darker;
        border-width: 2px !important;
        background-color: $color-3 !important;
        color: $lightest !important;
    }
}
</style>



// WEBPACK FOOTER //
// ChannelSelector.vue?7a3164e9